<script setup lang="ts">
import type { ReportColumn } from '../../../models/column.types'
import type { ReportFilter } from '../../../models/filter.types'
import { isFilterableCell } from '../../../service/reportCellKind'

import { useI18n } from '@/shared/i18n'
import { Button } from '@/shared/ui'

const props = defineProps<{
  column: ReportColumn
  value: unknown
}>()
const emit = defineEmits<{ 'add-filter': [filter: ReportFilter] }>()

const { t } = useI18n()

function addFilter(): void {
  emit('add-filter', { field: props.column.field, match_mode: 'equals', value: props.value })
}
</script>

<template>
  <!-- Revealed by the shared `Td`'s `group/td` hover, the same way the card view's action is. -->
  <Button
    v-if="isFilterableCell(column, value)"
    class="report-table__filter absolute end-xs top-1/2 -translate-y-1/2 pointer-events-none opacity-0 transition group-hover/td:pointer-events-auto group-hover/td:opacity-100 focus-visible:pointer-events-auto focus-visible:opacity-100 motion-reduce:transition-none"
    size="xs"
    variant="soft"
    density="compact"
    :aria-label="t('reports.card.filterBy', { label: column.header })"
    data-testid="report-table-filter"
    @click.stop="addFilter"
  >
    {{ t('reports.card.filter') }}
  </Button>
</template>
